// Route table lives in App.tsx (export AppRoutes); this module also lists the
// pages pre-rendered with real content at build time (scripts/prerender.mjs).
export { AppRoutes } from "./App";

export const SSG_ROUTE_MODULES: Record<string, () => Promise<unknown>> = {
  "/ciencia/antioxidantes-protecao": () => import("./pages/ciencia/AntioxidantesProtecao"),
  "/ciencia/barreira-cutanea": () => import("./pages/ciencia/BarreiraCutanea"),
  "/ciencia/barreira-lipidica": () => import("./pages/ciencia/BarreiraLipidica"),
  "/ciencia/conforto-suavidade": () => import("./pages/ciencia/ConfortoSuavidade"),
  "/ciencia/dermocosmetica-cientifica": () => import("./pages/ciencia/DermocosmeticaCientifica"),
  "/ciencia/desreguladores-endocrinos": () => import("./pages/ciencia/DesreguladoresEndocrinos"),
  "/ciencia/formulacao-de-alta-tolerabilidade": () => import("./pages/ciencia/FormulacaoAltaTolerabilidade"),
  "/ciencia/hidratacao-matriz": () => import("./pages/ciencia/HidratacaoMatriz"),
  "/ciencia/microbiota-cutanea": () => import("./pages/ciencia/MicrobiotaCutanea"),
  "/ciencia/pele-sensivel-fisiologia": () => import("./pages/ciencia/PeleSensivelFisiologia"),
  "/ciencia/ph-fisiologico-da-pele": () => import("./pages/ciencia/PHFisiologicoPele"),
  "/ciencia/reparo-cutaneo": () => import("./pages/ciencia/ReparoCutaneo"),
  "/ciencia/sistema-multissurfactante-suave": () => import("./pages/ciencia/SistemaMultissurfactante"),
  "/ciencia/tewl-perda-transepidermica-de-agua": () => import("./pages/ciencia/TEWLPerdaTransepidermica"),
  "/faq": () => import("./pages/FAQ"),
  "/sobre": () => import("./pages/About"),
};

export const SSG_ROUTES = Object.keys(SSG_ROUTE_MODULES);
